import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DialogGoogleMapComponent} from '../../../Dialogs/dialog-google-map/dialog-google-map.component';
import {IDialogMapReturn} from '../../../../interface/dataset-params';
import {FormEventService} from '../../../../services/formEventService';

@Component({
    selector: 'noos-mapfield',
    templateUrl: './mapfield.component.html',
    styleUrls: ['./mapfield.component.scss']
})
@NoosFormTypeService.register('map_field')
export class MapfieldComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor(private dialog: MatDialog, private eventListenerService: FormEventService) {
    }

    ngOnInit() {
    }


    ngAfterViewInit(): void {
    }


    onOpenDialog() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.width = '750px';
        dialogConfig.data = this.prop.defaultValue;

        const dialogRef = this.dialog.open(DialogGoogleMapComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result: IDialogMapReturn) => {
            if (result) {
                this.prop.defaultValue = result.latitude.toString() + ',' + result.longitude.toString();
                this.prop.defaultValueTitle = result.address;
                if (this.prop.defaultValue || this.prop.defaultValue !== '') {
                    this.eventListenerService.updatedDataSelection({
                        fromComponentId: this.prop.id,
                        fromComponentName: this.prop.name,
                        eventName: 'select_address',
                        triggerValue: result.address,
                        formId: this.formId,
                        datasetId: this.datasetId
                    });
                }
            }
        });

    }

}
